import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-tickets-1 }}\n{{outlet}}",{ moduleName: "embercom/templates/apps/app/feed.hbs" })